// NOTE: There are some slugs the Blizzard API requires that does not match how
// they defined their routine for converting from names to slugs, and is inconsistent
// with how you see realm names being converted into slugs.
//
// So, we just forcibly map from the common routine to Blizzard's actual value here
// for a couple of exceptions (basically any boss name with a dash in it).
const SLUG_OVERRIDES: { [key: string]: string } = {
  'eonar-the-lifebinder': 'eonar-the-life-binder',
  'raden-the-despoiled': 'ra-den-the-despoiled'
};

// Convert from a name to a slug.
// This follows Blizzard's slugging rules, with their caveats.
// Our original statement from them was:
//
// ----
// sluggifying for all docs converts whitespace to hyphen, strips invalid chars (punct etc.,
// which shouldn't be allowed for guild/char names anyway), and converts to lowercase
// ----
export function slugify(str: string) {
  let slugged = (str || '').toLowerCase();

  // FIXME: Right now this can received already slugged strings.
  // If we just remove dashes without abandon then we will ruin slugged
  // strings that get passed into this. So for now we just say if the
  // string has any uppercase or spaces then we need to slug it
  if (slugged !== str || slugged.indexOf(' ') !== -1) {
    // 1) Remove all punctuation except dashes
    slugged = slugged.replace(/[!@#$%^&\*\(\)~`_\+=\[\]\{\};:"\.\,<>\/?'\-•]/g, '');

    // 2) Replace spaces with dashes
    slugged = slugged.replace(/\s+/g, '-');

    // 3) Lowercase it
    slugged = slugged.toLowerCase();
  }

  return SLUG_OVERRIDES[slugged] || slugged;
}

// wow realms have special slugification rules
export const wowGameDataSlugify = slugify;

// validate some behavior we rely on
// assert.ok(slugify('Ra-den the Despoiled') === 'ra-den-the-despoiled');
// assert.ok(slugify('Azjol-Nerub') === 'azjolnerub');
// assert.ok(slugify('previously--slugged-string') === 'previously--slugged-string');
// assert.ok(slugify(`N'Zoth the Corruptor`) === 'nzoth-the-corruptor');
// assert.ok(slugify('Конклав Альянса') === 'конклав-альянса');
// assert.ok(slugify('Mythic Dungeon Heroes - EU') === 'mythic-dungeon-heroes-eu');
